import { render } from "./FooterVue.vue?vue&type=template&id=70d46e84&scoped=true"
const script = {}

import "./FooterVue.vue?vue&type=style&index=0&id=70d46e84&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/data/workspace/gym-official-web_prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d46e84"]])

export default __exports__